import React, { useEffect, useState } from 'react';
import {
  useModulesByCategory,
  useToggleModule,
  useInitializeModules,
  SystemModule,
} from '../hooks/useSystemModules';
import { UserAccessControl } from './UserAccessControl';

// ==================== SVG ICONS ====================

const BoxIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
    <polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>
  </svg>
);

const LockIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
);

const SettingsIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
  </svg>
);

const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

const XIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);

const AlertIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
  </svg>
);

const RefreshIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
  </svg>
);

const StarIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
  </svg>
);

const ChartIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M18 20V10M12 20V4M6 20v-6"/>
  </svg>
);

const DiceIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8" cy="8" r="1" fill="currentColor"/><circle cx="16" cy="8" r="1" fill="currentColor"/><circle cx="8" cy="16" r="1" fill="currentColor"/><circle cx="16" cy="16" r="1" fill="currentColor"/><circle cx="12" cy="12" r="1" fill="currentColor"/>
  </svg>
);

const DollarIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
  </svg>
);

const ClockIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
  </svg>
);

const FileTextIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
  </svg>
);

const PlusIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
  </svg>
);

const GridIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
  </svg>
);

const ToggleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="1" y="5" width="22" height="14" rx="7" ry="7"/><circle cx="16" cy="12" r="3"/>
  </svg>
);

const CalculatorIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="4" y="2" width="16" height="20" rx="2"/><line x1="8" y1="6" x2="16" y2="6"/><line x1="8" y1="10" x2="8" y2="10.01"/><line x1="12" y1="10" x2="12" y2="10.01"/><line x1="16" y1="10" x2="16" y2="10.01"/><line x1="8" y1="14" x2="8" y2="14.01"/><line x1="12" y1="14" x2="12" y2="14.01"/><line x1="16" y1="14" x2="16" y2="14.01"/><line x1="8" y1="18" x2="8" y2="18.01"/><line x1="12" y1="18" x2="12" y2="18.01"/><line x1="16" y1="18" x2="16" y2="18.01"/>
  </svg>
);

const SlidersIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="10" x2="4" y2="3"/><line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="3"/><line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="12" x2="20" y2="3"/><line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="17" y1="16" x2="23" y2="16"/>
  </svg>
);

// Mapeo de emojis a componentes SVG
const getModuleIcon = (icon: string | undefined): React.ReactNode => {
  const iconMap: Record<string, React.ReactNode> = {
    '🔄': <RefreshIcon />,
    '🎲': <DiceIcon />,
    '💰': <DollarIcon />,
    '💵': <DollarIcon />,
    '📊': <ChartIcon />,
    '⚙️': <SlidersIcon />,
    '🕐': <ClockIcon />,
    '🕒': <ClockIcon />,
    '📋': <FileTextIcon />,
    '➕': <PlusIcon />,
    '📦': <BoxIcon />,
    '🔧': <SettingsIcon />,
    '⚡': <ToggleIcon />,
    '🧮': <CalculatorIcon />,
    '📱': <GridIcon />,
  };

  if (!icon) return <BoxIcon />;
  return iconMap[icon] || <BoxIcon />;
};

// ==================== STYLES ====================

const styles = `
  .cfg-panel {
    padding: 0;
  }

  .cfg-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
  }

  .cfg-header h2 {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: #1e3a8a;
  }

  .cfg-header svg {
    color: #2563eb;
  }

  .cfg-loading {
    padding: 2rem;
    text-align: center;
    color: #64748b;
    font-size: 0.8rem;
  }

  .cfg-spinner {
    width: 24px;
    height: 24px;
    border: 2px solid #e2e8f0;
    border-top-color: #2563eb;
    border-radius: 50%;
    animation: cfg-spin 1s linear infinite;
    margin: 0 auto 10px;
  }

  @keyframes cfg-spin {
    to { transform: rotate(360deg); }
  }

  .cfg-error {
    padding: 1rem;
    background: #fef2f2;
    border-left: 4px solid #ef4444;
    border-radius: 6px;
    color: #991b1b;
    font-size: 0.8rem;
  }

  .cfg-error button {
    margin-top: 8px;
    padding: 4px 10px;
    background: #2563eb;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 0.75rem;
    cursor: pointer;
  }

  /* Notification */
  .cfg-notif {
    position: fixed;
    top: 70px;
    right: 16px;
    padding: 10px 14px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    gap: 8px;
    z-index: 1000;
    animation: cfg-slideIn 0.3s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    font-size: 0.75rem;
  }

  .cfg-notif.success {
    background: #f0fdf4;
    color: #166534;
    border: 1px solid #bbf7d0;
  }

  .cfg-notif.error {
    background: #fef2f2;
    color: #991b1b;
    border: 1px solid #fecaca;
  }

  .cfg-notif.warning {
    background: #fffbeb;
    color: #92400e;
    border: 1px solid #fde68a;
  }

  .cfg-notif button {
    background: none;
    border: none;
    font-size: 1rem;
    cursor: pointer;
    opacity: 0.7;
    padding: 0;
    line-height: 1;
  }

  .cfg-notif button:hover {
    opacity: 1;
  }

  @keyframes cfg-slideIn {
    from { transform: translateX(100%); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }

  /* Tabs */
  .cfg-tabs {
    display: flex;
    gap: 6px;
    padding: 4px;
    background: #f1f5f9;
    border-radius: 6px;
    margin-bottom: 16px;
  }

  .cfg-tab {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    background: transparent;
    border: none;
    border-radius: 4px;
    color: #64748b;
    font-size: 0.8rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .cfg-tab:hover {
    background: rgba(37, 99, 235, 0.1);
    color: #2563eb;
  }

  .cfg-tab.active {
    background: #fff;
    color: #1e40af;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .cfg-tab svg {
    flex-shrink: 0;
  }

  /* Info Box */
  .cfg-info {
    background: #f8fafc;
    padding: 10px 14px;
    border-radius: 6px;
    margin-bottom: 16px;
    border-left: 4px solid #2563eb;
  }

  .cfg-info p {
    margin: 0;
    color: #64748b;
    font-size: 0.75rem;
    line-height: 1.5;
  }

  /* Category Section */
  .cfg-categories {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .cfg-category {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-left: 4px solid #2563eb;
    border-radius: 6px;
    padding: 12px 14px;
  }

  .cfg-category-title {
    margin: 0 0 12px;
    font-size: 0.85rem;
    font-weight: 600;
    color: #1e40af;
    padding-bottom: 8px;
    border-bottom: 1px solid #e2e8f0;
  }

  /* Modules Grid */
  .cfg-modules-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 10px;
  }

  .cfg-module {
    background: #f8fafc;
    border-radius: 6px;
    padding: 10px 12px;
    border: 1px solid #e2e8f0;
    transition: all 0.2s ease;
  }

  .cfg-module.enabled {
    border-color: #22c55e;
    background: #f0fdf4;
  }

  .cfg-module.disabled {
    border-color: #cbd5e1;
    opacity: 0.7;
  }

  .cfg-module.core {
    border-color: #2563eb;
    background: #eff6ff;
  }

  .cfg-module-header {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 6px;
  }

  .cfg-module-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2563eb;
    flex-shrink: 0;
  }

  .cfg-module.enabled .cfg-module-icon {
    color: #22c55e;
  }

  .cfg-module.core .cfg-module-icon {
    color: #2563eb;
  }

  .cfg-module-info {
    flex: 1;
    min-width: 0;
  }

  .cfg-module-name {
    margin: 0;
    font-size: 0.8rem;
    font-weight: 600;
    color: #1e3a8a;
  }

  .cfg-module-path {
    margin: 2px 0 0;
    font-size: 0.65rem;
    color: #94a3b8;
    font-family: monospace;
  }

  .cfg-module-desc {
    margin: 0 0 8px;
    font-size: 0.7rem;
    color: #64748b;
    line-height: 1.4;
  }

  .cfg-module-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .cfg-badge {
    font-size: 0.6rem;
    font-weight: 600;
    padding: 2px 6px;
    border-radius: 3px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  .cfg-badge.active {
    background: #dcfce7;
    color: #166534;
  }

  .cfg-badge.inactive {
    background: #f1f5f9;
    color: #64748b;
  }

  .cfg-badge.core {
    background: #dbeafe;
    color: #1e40af;
  }

  /* Toggle Switch */
  .cfg-toggle {
    position: relative;
    display: inline-block;
    width: 36px;
    height: 20px;
  }

  .cfg-toggle input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .cfg-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #cbd5e1;
    transition: 0.3s;
    border-radius: 20px;
  }

  .cfg-slider:before {
    position: absolute;
    content: "";
    height: 14px;
    width: 14px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  }

  .cfg-toggle input:checked + .cfg-slider {
    background-color: #22c55e;
  }

  .cfg-toggle input:checked + .cfg-slider:before {
    transform: translateX(16px);
  }

  .cfg-toggle input:disabled + .cfg-slider {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .cfg-slider.core {
    background-color: #2563eb;
  }

  .cfg-toggle input:checked + .cfg-slider.core {
    background-color: #2563eb;
  }

  .cfg-module-meta {
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid #e2e8f0;
    font-size: 0.6rem;
    color: #94a3b8;
  }

  /* Summary Section */
  .cfg-summary {
    margin-top: 16px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-left: 4px solid #2563eb;
    border-radius: 6px;
    padding: 12px 14px;
  }

  .cfg-summary-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e2e8f0;
  }

  .cfg-summary-header h3 {
    margin: 0;
    font-size: 0.8rem;
    font-weight: 600;
    color: #1e40af;
  }

  .cfg-summary-header svg {
    color: #3b82f6;
  }

  .cfg-summary-grid {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
  }

  .cfg-stat {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 16px;
    background: #f8fafc;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
    min-width: 80px;
  }

  .cfg-stat-value {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1e40af;
  }

  .cfg-stat-label {
    font-size: 0.65rem;
    color: #64748b;
    margin-top: 2px;
    text-align: center;
  }

  @media (max-width: 640px) {
    .cfg-modules-grid {
      grid-template-columns: 1fr;
    }

    .cfg-summary-grid {
      justify-content: center;
    }

    .cfg-tabs {
      flex-direction: column;
    }

    .cfg-tab {
      justify-content: center;
    }
  }
`;

interface ConfigurationPanelProps {
  onConfigUpdate?: () => void;
}

type TabType = 'modules' | 'access';

export const ConfigurationPanel: React.FC<ConfigurationPanelProps> = () => {
  const { categories, loading, error, refetch } = useModulesByCategory();
  const { toggle, loading: toggling } = useToggleModule();
  const { initialize, loading: initializing } = useInitializeModules();

  const [activeTab, setActiveTab] = useState<TabType>('modules');
  const [notification, setNotification] = useState<{
    type: 'success' | 'error' | 'warning';
    message: string;
  } | null>(null);

  useEffect(() => {
    if (!loading && categories.length === 0) {
      initialize().then(() => {
        refetch();
      });
    }
  }, [loading, categories.length]);

  const handleToggleModule = async (module: SystemModule) => {
    if (module.isCore) {
      setNotification({
        type: 'warning',
        message: `"${module.name}" es un módulo esencial y no puede deshabilitarse`,
      });
      setTimeout(() => setNotification(null), 3000);
      return;
    }

    try {
      await toggle(module.key, !module.enabled);
      setNotification({
        type: 'success',
        message: `Módulo "${module.name}" ${!module.enabled ? 'habilitado' : 'deshabilitado'}`,
      });
      refetch();
    } catch (err: any) {
      setNotification({
        type: 'error',
        message: err.message || 'Error al cambiar el estado del módulo',
      });
    }
    setTimeout(() => setNotification(null), 3000);
  };

  if (loading || initializing) {
    return (
      <div className="cfg-panel">
        <style>{styles}</style>
        <div className="cfg-header">
          <SettingsIcon />
          <h2>Configuración del Sistema</h2>
        </div>
        <div className="cfg-loading">
          <div className="cfg-spinner"></div>
          <p>Cargando configuración...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="cfg-panel">
        <style>{styles}</style>
        <div className="cfg-header">
          <SettingsIcon />
          <h2>Configuración del Sistema</h2>
        </div>
        <div className="cfg-error">
          <p>Error al cargar la configuración: {error.message}</p>
          <button onClick={() => refetch()}>
            <RefreshIcon /> Reintentar
          </button>
        </div>
      </div>
    );
  }

  const displayCategories = categories.filter(cat => cat.key !== 'core');

  return (
    <div className="cfg-panel">
      <style>{styles}</style>

      <div className="cfg-header">
        <SettingsIcon />
        <h2>Configuración del Sistema</h2>
      </div>

      {/* Notification */}
      {notification && (
        <div className={`cfg-notif ${notification.type}`}>
          {notification.type === 'success' && <CheckIcon />}
          {notification.type === 'error' && <XIcon />}
          {notification.type === 'warning' && <AlertIcon />}
          {notification.message}
          <button onClick={() => setNotification(null)}>×</button>
        </div>
      )}

      {/* Tabs */}
      <div className="cfg-tabs">
        <button
          className={`cfg-tab ${activeTab === 'modules' ? 'active' : ''}`}
          onClick={() => setActiveTab('modules')}
        >
          <BoxIcon /> Módulos del Sistema
        </button>
        <button
          className={`cfg-tab ${activeTab === 'access' ? 'active' : ''}`}
          onClick={() => setActiveTab('access')}
        >
          <LockIcon /> Permisos de Acceso
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === 'access' ? (
        <UserAccessControl />
      ) : (
        <>
          {/* Info Box */}
          <div className="cfg-info">
            <p>
              Habilita o deshabilita los módulos del sistema según las necesidades del cliente.
              Los módulos deshabilitados no aparecerán en el menú de navegación.
            </p>
          </div>

          {/* Categories */}
          <div className="cfg-categories">
            {displayCategories.map((category) => (
              <div key={category.key} className="cfg-category">
                <h3 className="cfg-category-title">{category.name}</h3>
                <div className="cfg-modules-grid">
                  {category.modules.map((module) => (
                    <div
                      key={module.id}
                      className={`cfg-module ${module.enabled ? 'enabled' : 'disabled'} ${module.isCore ? 'core' : ''}`}
                    >
                      <div className="cfg-module-header">
                        <span className="cfg-module-icon">{getModuleIcon(module.icon ?? undefined)}</span>
                        <div className="cfg-module-info">
                          <h4 className="cfg-module-name">{module.name}</h4>
                          <p className="cfg-module-path">{module.path}</p>
                        </div>
                      </div>

                      {module.description && (
                        <p className="cfg-module-desc">{module.description}</p>
                      )}

                      <div className="cfg-module-footer">
                        <div>
                          {module.isCore ? (
                            <span className="cfg-badge core">
                              <StarIcon /> Esencial
                            </span>
                          ) : (
                            <span className={`cfg-badge ${module.enabled ? 'active' : 'inactive'}`}>
                              {module.enabled ? 'Activo' : 'Inactivo'}
                            </span>
                          )}
                        </div>

                        <label className="cfg-toggle">
                          <input
                            type="checkbox"
                            checked={module.enabled}
                            onChange={() => handleToggleModule(module)}
                            disabled={toggling || module.isCore}
                          />
                          <span className={`cfg-slider ${module.isCore ? 'core' : ''}`}></span>
                        </label>
                      </div>

                      {module.lastChangedBy && (
                        <div className="cfg-module-meta">
                          Modificado por: {module.lastChangedBy}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Summary */}
          <div className="cfg-summary">
            <div className="cfg-summary-header">
              <ChartIcon />
              <h3>Resumen</h3>
            </div>
            <div className="cfg-summary-grid">
              <div className="cfg-stat">
                <span className="cfg-stat-value">
                  {categories.reduce((acc, cat) => acc + cat.modules.filter(m => m.enabled).length, 0)}
                </span>
                <span className="cfg-stat-label">Activos</span>
              </div>
              <div className="cfg-stat">
                <span className="cfg-stat-value">
                  {categories.reduce((acc, cat) => acc + cat.modules.filter(m => !m.enabled).length, 0)}
                </span>
                <span className="cfg-stat-label">Inactivos</span>
              </div>
              <div className="cfg-stat">
                <span className="cfg-stat-value">
                  {categories.reduce((acc, cat) => acc + cat.modules.filter(m => m.isCore).length, 0)}
                </span>
                <span className="cfg-stat-label">Esenciales</span>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
